import React from 'react';
import './MainTitle.css';
function MainTitle({ title = '', subtitle = '' }) {
	return (
		<div className='maintitle'>
			<h1 className='maintitle__text'>{title}</h1>
			<h3 className='maintitle__subtitle'>{subtitle}</h3>
		</div>
	);
}

export default MainTitle;
